export default function Portfolio() {
    return (
        <div>
            <h1>Portfolio</h1>
        </div>
    );
}
